import Breadcrumbs, { BreadcrumbsProps } from '@material-ui/core/Breadcrumbs';

export type DSBreadcrumbsProps = BreadcrumbsProps;
export const DSBreadcrumbs = Breadcrumbs;
